var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 29,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 29,
    stroke: "#F54103",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2451 29.0147L19.9127 30.7023C19.668 30.2243 19.5199 29.9326 19.4684 29.8273C18.9363 28.7396 18.6772 27.7543 18.6911 26.8716C18.705 25.989 19.0332 24.8377 19.6757 23.4177C20.3182 21.9978 20.6775 21.0989 20.7535 20.7211C20.8656 20.128 20.7951 19.5727 20.5419 19.0551C20.1901 18.3358 19.6022 17.8673 18.7783 17.6497C17.9588 17.4189 17.0656 17.5484 16.0985 18.0381C15.1663 18.5102 14.5175 19.1727 14.152 20.0255C13.7864 20.8782 13.7543 21.9125 14.0554 23.1281L10.4778 24.4145C9.80558 22.7957 9.81546 21.127 10.5075 19.4084C11.2082 17.6853 12.5605 16.3164 14.5643 15.3016C16.6726 14.2339 18.6222 13.9416 20.413 14.4248C22.1995 14.8992 23.4532 15.8733 24.1741 17.347C24.5732 18.1629 24.7199 19.0518 24.6143 20.0137C24.5174 20.9712 24.0266 22.4567 23.1417 24.47C22.6839 25.5118 22.4557 26.2786 22.4571 26.7705C22.4672 27.2579 22.7299 28.006 23.2451 29.0147ZM22.3457 35.6763L20.537 31.9787L24.2092 30.119L26.0179 33.8166L22.3457 35.6763Z",
    fill: "#F54103"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4433 40.7374L33.0047 39.39C33.178 38.6029 33.2851 38.1239 33.326 37.9529C33.7487 36.1864 34.3879 34.8055 35.2436 33.8102C36.0993 32.815 37.5721 31.8217 39.6619 30.8303C41.7516 29.839 43.02 29.1648 43.4669 28.8077C44.1601 28.2399 44.6072 27.5358 44.8083 26.6953C45.0879 25.5271 44.8573 24.4136 44.1166 23.3548C43.3935 22.2853 42.2429 21.5551 40.6646 21.1641C39.1432 20.7872 37.7667 20.9064 36.535 21.5218C35.3033 22.1372 34.2824 23.2877 33.4724 24.9734L28.1334 22.9263C28.9001 20.415 30.4989 18.5173 32.9298 17.2332C35.375 15.9526 38.2327 15.7174 41.503 16.5276C44.9439 17.3801 47.4645 18.9628 49.0648 21.2758C50.6685 23.5746 51.184 25.9207 50.6113 28.314C50.2942 29.6389 49.6174 30.7992 48.5809 31.795C47.5586 32.7942 45.5809 34.0095 42.6478 35.4409C41.13 36.1816 40.1381 36.8337 39.6719 37.3973C39.2199 37.9644 38.8103 39.0778 38.4433 40.7374ZM31.0718 47.4676L32.5087 41.4628L38.5018 42.9476L37.0649 48.9524L31.0718 47.4676Z",
    fill: "#F54103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecret);
export default __webpack_public_path__ + "static/media/secret.1383098be4f430f44a55628f80fbf34d.svg";
export { ForwardRef as ReactComponent };